import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import * as Yup from "yup";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  editId: string;
  loading: boolean;
  initialValues: {
    id?: string;
    name: string;
    hours: string;
    color: string;
    isActive: boolean;
  };
  addBtnLoading: boolean;
  snackbar: {
    open: boolean;
    severity: "error" | "success" | "info" | "warning" | undefined;
    message: string;
  };
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class EditLateDeliveryConfigController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getLateDeliveryConfigCallId: string = "";
  updateLateDeliveryConfigCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.state = {
      // Customizable Area Start
      editId: "",
      loading: false,
      initialValues: {
        name: "",
        hours: "",
        color: "#000000",
        isActive: false,
      },
      addBtnLoading: false,
      snackbar: {
        open: false,
        severity: "info",
        message: "",
      },
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);

    if (getName(MessageEnum.RestAPIResponceMessage) !== message.id) {
      return;
    }

    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (apiRequestCallId === this.getLateDeliveryConfigCallId) {
      this.setState({ loading: false });
      this.handlePrefilledResponse(responseJson);
    }

    if (apiRequestCallId === this.updateLateDeliveryConfigCallId) {
      this.handleEditResponse(responseJson);
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    super.componentDidMount();
    const editId = this.props.navigation.getParam("id", "");
    console.log("=== EDIT COMPONENT DID MOUNT ===");
    console.log("Received ID from navigation:", editId);
    console.log("Navigation object:", this.props.navigation);

    if (!editId) {
      console.error("No ID provided! Cannot fetch config.");
      this.setState({ loading: false });
      alert("Error: No configuration ID provided");
      return;
    }

    this.setState({
      editId: editId,
    });
    console.log("About to call getLateDeliveryConfig with ID:", editId);
    this.getLateDeliveryConfig(editId);
  }

  componentDidUpdate(prevProps: Props, prevState: S) {
    if (prevState.editId !== this.state.editId) {
      this.getLateDeliveryConfig(this.state.editId);
    }
  }

  FormSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    hours: Yup.string()
      .required("Hours is required")
      .matches(/^\d+$/, "Hours must be a valid number")
      .test(
        "positive-number",
        "Hours must be greater than 0",
        (value) => {
          const numericValue = parseInt(value);
          return !isNaN(numericValue) && numericValue > 0;
        }
      ),
    color: Yup.string().required("Color is required"),
  });

  getLateDeliveryConfig = (id: string) => {
    console.log("=== GET LATE DELIVERY CONFIG (EDIT) ===");
    console.log("Config ID:", id);

    if (!id) {
      console.error("Cannot fetch - no config ID!");
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });

    const endpoint = `${configJSON.LateDeliveryListPage.ApiUrls.getLateDeliveryList}/${id}`;
    console.log("API Endpoint:", endpoint);

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("token"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getLateDeliveryConfigCallId = requestMessage.messageId;
    console.log("Request Message ID:", requestMessage.messageId);

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    console.log("Sending API request...");
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePrefilledResponse = (responseJson: any) => {
    console.log("=== RECEIVED API RESPONSE (EDIT) ===");
    console.log("Response:", responseJson);

    if (!responseJson) {
      console.error("No response received");
      this.setState({ loading: false });
      return;
    }

    if (responseJson.errors) {
      console.error("=== API ERROR (EDIT) ===");
      console.error("API Error:", responseJson.errors);
      this.parseApiErrorResponse(responseJson);
      this.setState({ loading: false });
      return;
    }

    if (responseJson && responseJson.data && responseJson.data.attributes) {
      const config = responseJson.data;
      console.log("Parsing config data:", config);
      const parsedData = {
        id: config.id,
        name: config.attributes.name || "",
        hours: config.attributes.hours?.toString() || "",
        color: config.attributes.color || "#000000",
        isActive: config.attributes.is_active || false,
      };

      console.log("Setting initial values:", parsedData);
      this.setState({
        initialValues: parsedData,
        loading: false,
      });
      console.log("State updated successfully");
    } else {
      console.error("=== INVALID RESPONSE STRUCTURE ===");
      console.error("Invalid response structure:", responseJson);
      this.setState({ loading: false });
    }
  };

  handleEditResponse = (responseJson: any) => {
    if (responseJson !== undefined && responseJson.error === undefined) {
      this.setState({
        snackbar: {
          message: "Late Delivery Config updated successfully",
          severity: "success",
          open: true,
        },
      });

      setTimeout(() => {
        this.props.navigation.navigate("LateDeliveryList");
      }, 2000);
    } else {
      this.setState({
        addBtnLoading: false,
        snackbar: {
          message: responseJson?.errors?.[0]?.message || "Failed to update configuration",
          severity: "error",
          open: true,
        },
      });
    }
  };

  updateLateDeliveryConfig = (values: any) => {
    this.setState({
      addBtnLoading: true,
    });

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("token"),
    };

    const httpBody = {
      data: {
        name: values.name,
        hours: parseInt(values.hours),
        color: values.color,
        is_active: values.isActive,
      },
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateLateDeliveryConfigCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.LateDeliveryListPage.ApiUrls.getLateDeliveryList}/${this.state.editId}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PATCH"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleCloseSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        severity: "info",
        message: "",
      },
    });
  };

  handleCancelForm = () => {
    this.props.navigation.navigate("LateDeliveryList");
  };
  // Customizable Area End
}
